window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  },
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
    }
    return cookieEnabled;
  },
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass =
      typeof options.tableWrapperClass === "undefined"
        ? ""
        : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass =
      typeof options.iframeWrapperClass === "undefined"
        ? ""
        : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  },
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:section:reorder", this._onReorder.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === "function") {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onSelect === "function") {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onReorder === "function") {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(
      this.instances,
      "id",
      evt.detail.sectionId
    );

    if (instance && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = "${{amount}}";

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ",");
      decimal = slate.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, "&nbsp;", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, "&nbsp;");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();
      if (!variant) {
        return;
      }

      this.$container.trigger({
        type: "variantChange",
        variant: variant,
      });

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id +
        window.location.hash;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },
  });

  return Variants;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

// See https://docs.shopify.com/themes/customization/navigation/link-product-options-in-menus
var OptionsLinker = {
  arrayIncludes: function (e, t) {
    for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
    return !1;
  },

  uniq: function (e) {
    for (var t = [], n = 0; n < e.length; n++)
      OptionsLinker.arrayIncludes(t, e[n]) || t.push(e[n]);
    return t;
  },
  optionsMap: {},
  getSelector: function (index) {
    return "[data-single-option-selector][data-index=option" + index + "]";
  },
  updateOptionsInSelector: function (selectorIndex) {
    var selector = OptionsLinker.getSelector(selectorIndex + 1);
    switch (selectorIndex) {
      case 0:
        var key = "root";
        break;
      case 1:
        var key = $(
          OptionsLinker.getSelector(selectorIndex) + ":checked"
        ).val();
        break;
      case 2:
        var key =
          $(OptionsLinker.getSelector(selectorIndex - 1) + ":checked").val() +
          " / " +
          $(OptionsLinker.getSelector(selectorIndex) + ":checked").val();
    }

    var availableOptions = OptionsLinker.optionsMap[key];
    if (!availableOptions || availableOptions.length <= 1) {
      $(selector).parents(".options-selector").hide();
    } else {
      $(selector).parents(".options-selector").show();
    }

    $(selector).each(function () {
      if ($.inArray($(this).val(), availableOptions) === -1) {
        $(this)
          .prop("disabled", true)
          .parent(".grid__item")
          .addClass("disabled");
      } else {
        $(this)
          .prop("disabled", false)
          .parent(".grid__item")
          .removeClass("disabled");
      }
    });

    // If initialValue is not available, we switch to first available
    var initialValue = $(selector + ":checked").val();
    if ($.inArray(initialValue, availableOptions) === -1) {
      $(selector + ":not(:disabled):first")
        .prop("checked", true)
        .trigger("change");
    }
  },
  linkOptionSelectors: function (product) {
    // Building our mapping object.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available && variant.option2 !== "Spéciale") {
        // Hack to hide Spéciale Clavex
        // Gathering values for the 1st drop-down.
        OptionsLinker.optionsMap["root"] =
          OptionsLinker.optionsMap["root"] || [];
        OptionsLinker.optionsMap["root"].push(variant.option1);
        OptionsLinker.optionsMap["root"] = OptionsLinker.uniq(
          OptionsLinker.optionsMap["root"]
        );
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          OptionsLinker.optionsMap[key] = OptionsLinker.optionsMap[key] || [];
          OptionsLinker.optionsMap[key].push(variant.option2);
          OptionsLinker.optionsMap[key] = OptionsLinker.uniq(
            OptionsLinker.optionsMap[key]
          );
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + " / " + variant.option2;
          OptionsLinker.optionsMap[key] = OptionsLinker.optionsMap[key] || [];
          OptionsLinker.optionsMap[key].push(variant.option3);
          OptionsLinker.optionsMap[key] = OptionsLinker.uniq(
            OptionsLinker.optionsMap[key]
          );
        }
      }
    }

    // Update options right away.
    OptionsLinker.updateOptionsInSelector(0);
    if (product.options.length > 1) OptionsLinker.updateOptionsInSelector(1);
    if (product.options.length === 3) OptionsLinker.updateOptionsInSelector(2);
    // When there is an update in the first dropdown.
    $(OptionsLinker.getSelector(1)).change(function () {
      OptionsLinker.updateOptionsInSelector(1);
      if (product.options.length === 3)
        OptionsLinker.updateOptionsInSelector(2);
      return true;
    });
    // When there is an update in the second dropdown.
    $(OptionsLinker.getSelector(2)).change(function () {
      if (product.options.length === 3)
        OptionsLinker.updateOptionsInSelector(2);
      return true;
    });
  },
};

theme.Product = (function () {
  function getMaxSizeImgUrl(imgUrl) {
    var imgSize = slate.Image.imageSize(imgUrl);
    var maxImageSize = "4472x";
    return imgUrl.replace("_" + imgSize + "@2x.", "_" + maxImageSize + "@2x.");
  }

  function getFormDataAsJson($form) {
    var _ = {};
    $.map($form.serializeArray(), function (n) {
      const keys = n.name.match(/[a-zA-Z0-9_]+|(?=\[\])/g);
      if (keys.length > 1) {
        let tmp = _;
        pop = keys.pop();
        for (let i = 0; i < keys.length, (j = keys[i]); i++) {
          (tmp[j] = !tmp[j] ? (pop == "" ? [] : {}) : tmp[j]), (tmp = tmp[j]);
        }
        if (pop == "")
          (tmp = !Array.isArray(tmp) ? [] : tmp), tmp.push(n.value);
        else tmp[pop] = n.value;
      } else _[keys.pop()] = n.value;
    });
    return _;
  }

  var selectors = {
    addToCartForm: 'form[action="/cart/add"]',
    cartCount: ".cart-count",
    addToCartButton: "[data-add-to-cart]",
    addToCartButtonText: "[data-add-to-cart-text]",
    addingToCartButtonText: "[data-adding-to-cart-text]",
    addedToCartAlert: "[data-added-to-cart-alert]",
    addedToCartError: "[data-added-to-cart-error]",
    comparePrice: "[data-compare-price]",
    comparePriceText: "[data-compare-text]",
    originalSelectorId: "[data-product-select]",
    priceWrapper: "[data-price-wrapper]",
    productFeaturedImage: "[data-product-featured-image]",
    productJson: "[data-product-json]",
    productPrice: "[data-product-price]",
    productThumbs: "[data-product-single-thumbnail]",
    singleOptionSelector: "[data-single-option-selector]",
    propertySelector: "[data-property-selector]",
    singlePropertySelector: "[data-single-property-selector]",
    quantitySelector: "[data-quantity-selector]",
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr("data-section-id");
    var productSingleObject = JSON.parse(
      $(selectors.productJson, this.$container).html()
    );
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data("enable-history-state") || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: productSingleObject,
    };

    this.settings = {};
    this.namespace = ".product";
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on(
      "variantChange" + this.namespace,
      this.updateAddToCartState.bind(this)
    );
    this.$container.on(
      "variantPriceChange" + this.namespace,
      this.updateProductPrices.bind(this)
    );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize =
        slate.Image.imageSize(this.$featuredImage.attr("src")) + "@2x";
      slate.Image.preload(productSingleObject.images, this.settings.imageSize);

      this.$container.on(
        "variantImageChange" + this.namespace,
        this.updateProductImage.bind(this)
      );
    }

    // Ajax cart
    var $addToCartForm = $(selectors.addToCartForm);
    var $addToCartButton = $addToCartForm.find(selectors.addToCartButton);
    var $addToCartButtonText = $addToCartForm.find(
      selectors.addToCartButtonText
    );
    var $addingToCartButtonText = $addToCartForm.find(
      selectors.addingToCartButtonText
    );
    var $addedToCartAlert = $addToCartForm.find(selectors.addedToCartAlert);
    var $addedToCartError = $addToCartForm.find(selectors.addedToCartError);
    var $cartCount = $(selectors.cartCount);

    function addToCart(payload) {
      $.ajax({
        url: "/cart/add.js",
        dataType: "json",
        type: "post",
        data: payload,
        success: function (itemData) {
          $.getJSON("/cart.js", function (cart) {
            // Re-enable add to cart button.
            $addToCartButton.removeClass("disabled").prop("disabled", false);
            $addingToCartButtonText.hide();
            $addToCartButtonText.show();
            $addedToCartAlert.show();

            // Update cart count
            $cartCount.html(cart.item_count);
            $cartCount.show();
          });
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
          $addedToCartError.html(response).show();
          $addToCartButton.prop("disabled", false).removeClass("disabled");
        },
      });
    }

    $addToCartForm.submit(function (e) {
      e.preventDefault();
      $addToCartButton.addClass("disabled").prop("disabled", true);
      $addedToCartAlert.hide();
      $addedToCartError.hide();
      $addToCartButtonText.hide();
      $addingToCartButtonText.show();
      const formData = getFormDataAsJson($addToCartForm);

      // Aller/Retour
      if (
        productSingleObject.handle === "gravene" &&
        formData.quantity > 1 &&
        formData.properties.couleur_haut !== formData.properties.couleur_bas
      ) {
        const leftQuantity = Math.ceil(formData.quantity / 2);
        $("#two-way-modal .left-quantity").html(`x${leftQuantity}`);
        const rightQuantity = Math.floor(formData.quantity / 2);
        $("#two-way-modal .right-quantity").html(`x${rightQuantity}`);

        $("#two-way-modal .left-image").html($(".featured-image").html());
        $("#two-way-modal .right-image").html($(".featured-image").html());
        const { couleur_haut, couleur_bas } = formData.properties;
        const topSelector =
          "#two-way-modal .right-image img[data-property='couleur_haut']";
        const bottomSelector =
          "#two-way-modal .right-image img[data-property='couleur_bas']";

        var topMedia = slate.utils.findInstance(
          productSingleObject.media,
          "alt",
          $(topSelector).attr("alt").replace(couleur_haut, couleur_bas)
        );
        var bottomMedia = slate.utils.findInstance(
          productSingleObject.media,
          "alt",
          $(bottomSelector).attr("alt").replace(couleur_bas, couleur_haut)
        );

        if (topMedia) {
          $(topSelector).attr(
            "src",
            topMedia.src.replace("https:", "").replace(".png", "_640x@2x.png")
          );
        }
        if (bottomMedia) {
          $(bottomSelector).attr(
            "src",
            bottomMedia.src
              .replace("https:", "")
              .replace(".png", "_640x@2x.png")
          );
        }

        $("#two-way-modal .accept")
          .off("click")
          .on("click", function (e) {
            $.modal.close();
            addToCart({
              items: [
                { ...formData, quantity: leftQuantity },
                {
                  ...formData,
                  quantity: rightQuantity,
                  properties: {
                    couleur_bas: couleur_haut,
                    couleur_haut: couleur_bas,
                    _custom_image: buildCloudinaryCollage(
                      "#two-way-modal .right-image img"
                    ),
                  },
                },
              ],
            });
          });
        e;

        $("#two-way-modal .refuse")
          .off("click")
          .on("click", function (e) {
            $.modal.close();
            addToCart({ items: [formData] });
          });

        $("#two-way-modal").modal({
          fadeDuration: 50,
          showClose: true,
        });
        $("#two-way-modal")
          .off()
          .on($.modal.CLOSE, function () {
            $addToCartButton.removeClass("disabled").prop("disabled", false);
            $addingToCartButtonText.hide();
            $addToCartButtonText.show();
          });
      } else {
        addToCart({ items: [formData] });
      }

      return false;
    });

    $(selectors.addToCartForm).on(
      "click",
      'button:not([type="submit"])',
      function (e) {
        e.preventDefault();
      }
    );

    function base64Encode(string) {
      return btoa(string)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/\=+$/, "");
    }

    function buildCloudinaryCollage(selector, size = "_300x@2x") {
      // Build cloudinary image with 3 images overlayed
      var imgSources = $(selector)
        .map(function (index, el) {
          return "https:" + $(el).attr("src").replace("_640x@2x", size);
        })
        .get();

      if (imgSources.length === 3) {
        var cloudinaryImgSrc =
          "https://res.cloudinary.com/maximumparis/image/fetch/l_fetch:" +
          encodeURIComponent(base64Encode(imgSources[1])) +
          "/l_fetch:" +
          encodeURIComponent(base64Encode(imgSources[2])) +
          "/" +
          encodeURIComponent(imgSources[0]);
        return cloudinaryImgSrc;
      }
    }

    // Product property selector
    if ($(selectors.singlePropertySelector, this.$container).length > 0) {
      function updateProductImageOnPropertyChange(el) {
        var property = $(el).attr("data-property");
        var label = $(el).attr("data-property-label");

        var imgSrc = $(el).attr("data-img-src");
        $(".featured-image img[data-property=" + property + "]").attr(
          "src",
          imgSrc
        );
        $(".featured-image img[data-property=" + property + "]").attr(
          "alt",
          $(el).attr("data-img-alt")
        );
        $(
          ".product-variant-options-values li[data-property=" + property + "]"
        ).text(label);

        var cloudinaryImgSrc = buildCloudinaryCollage(
          "#buy .featured-image img"
        );
        if (cloudinaryImgSrc) {
          $("input[data-property=_custom_image]").val(cloudinaryImgSrc);
        }

        console.log(buildCloudinaryCollage("#buy .featured-image img", ""));
      }

      function updatePropertiesOnVariantChange(variant) {
        var variant_handle = variant.option1.replace(/\./, "-");
        $(selectors.propertySelector + " .property", this.$container).hide();
        $(
          selectors.propertySelector +
            " .property[data-property-variants*=" +
            variant_handle +
            "]",
          this.$container
        ).show();
        // If current property is not compatible, select first one
        $(selectors.propertySelector, this.$container).each(function () {
          var currentValue = $(".property input:checked", this).val();
          var sameValueInput = $(
            ".property:visible input[value=" + currentValue + "]",
            this
          );
          var newInput = sameValueInput.length
            ? sameValueInput
            : $(".property:visible input:first", this);
          newInput.prop("checked", true);
          updateProductImageOnPropertyChange(newInput);
        });
      }
      // On init, set properties for current variant
      updatePropertiesOnVariantChange(this.variants.currentVariant);

      // Update property image on change
      $(selectors.singlePropertySelector, this.$container).on(
        "change",
        function () {
          updateProductImageOnPropertyChange(this);
        }
      );

      // On variant change, show only compatible property values + re select first
      this.$container.on("variantImageChange" + this.namespace, function (evt) {
        updatePropertiesOnVariantChange(evt.variant);
      });
    }

    // Quantity selector
    var quantityInput = $(
      selectors.quantitySelector + " input",
      this.$container
    );
    var quantityMinus = $(
      selectors.quantitySelector + " button.minus",
      this.$container
    );
    var quantityPlus = $(
      selectors.quantitySelector + " button.plus",
      this.$container
    );
    var that = this;
    quantityInput.on("change", function () {
      that.updateProductPrices({ variant: that.variants.currentVariant });
    });
    quantityMinus.on("click", function () {
      quantityInput[0].stepDown();
      that.updateProductPrices({ variant: that.variants.currentVariant });
    });
    quantityPlus.on("click", function () {
      quantityInput[0].stepUp();
      that.updateProductPrices({ variant: that.variants.currentVariant });
    });

    // Init Options Linker
    OptionsLinker.linkOptionSelectors(productSingleObject);

    // Init Zoom
    var supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;
    if (false && !supportsTouch) {
      var imageUrl = this.$featuredImage.attr("src");
      var maxImageUrl = getMaxSizeImgUrl(imageUrl);
      this.$featuredImage
        .wrap('<span style="display:inline-block" class="zoom-wrapper"></span>')
        .css("display", "block")
        .parent()
        .zoom({
          url: maxImageUrl,
          on: "click",
          onZoomIn: function () {
            $(this).addClass("active");
          },
          onZoomOut: function () {
            $(this).removeClass("active");
          },
        });

      slate.Image.loadImage(maxImageUrl);
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;
      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass("hide");
      } else {
        $(selectors.addToCartButton, this.$container).prop("disabled", true);
        $(selectors.addToCartButtonText, this.$container).html(
          theme.strings.unavailable
        );
        $(selectors.priceWrapper, this.$container).addClass("hide");
        return;
      }

      var quantityInput = $(
        selectors.quantitySelector + " input",
        this.$container
      );

      quantityInput.val(1).attr("value", 1);
      if (
        variant.inventory_quantity <= 0 &&
        variant.available &&
        variant.inventory_management != null
      ) {
        quantityInput.attr("max", 999);
      } else if (variant.inventory_management != null) {
        //Check if inventory management by shopify
        quantityInput.attr("max", variant.inventory_quantity);
      } else {
        quantityInput.attr("max", 999);
      }

      if (variant.available) {
        $(selectors.addToCartButton, this.$container).prop("disabled", false);
        $(selectors.addToCartButtonText, this.$container).html(
          theme.strings.addToCartButton
        );
      } else {
        $(selectors.addToCartButton, this.$container).prop("disabled", true);
        $(selectors.addToCartButtonText, this.$container).html(
          theme.strings.soldOut
        );
      }

      $(".product-variant-sku").html(variant.sku);
      for (var i = 0; i < variant.options.length; i++) {
        var option = variant.options[i];
        $(".product-variant-options-values li:nth-child(" + (i + 1) + ")").text(
          option
        );
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var quantityInput = $(
        selectors.quantitySelector + " input",
        this.$container
      );
      var quantity = quantityInput.val() || 1;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(
        selectors.comparePriceText,
        this.$container
      );

      $(selectors.productPrice, this.$container).html(
        slate.Currency.formatMoney(quantity * variant.price, theme.moneyFormat)
      );

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(
          slate.Currency.formatMoney(
            quantity * variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $compareEls.removeClass("hide");
      } else {
        $comparePrice.html("");
        $compareEls.addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(
        variant.featured_image.src,
        this.settings.imageSize
      );

      // Gravene hack to show only the layer with "pied"
      if (this.variants.product.handle === "gravene") {
        sizedImgUrl = sizedImgUrl.replace("typologie", "pied");
      }

      this.$featuredImage.attr("src", sizedImgUrl);

      // Update zoom
      var maxImageUrl = getMaxSizeImgUrl(sizedImgUrl);
      this.$featuredImage.parent().find(".zoomImg").attr("src", maxImageUrl);
      slate.Image.loadImage(maxImageUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function () {
      this.$container.off(this.namespace);
    },
  });

  return Product;
})();

theme.Cart = (function () {
  function Cart(container) {
    this.$container = $(container);
    var supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;
    if (!supportsTouch) {
      var cartGrid = document.getElementById("products-grid");
      var sortable = new Sortable(cartGrid, {
        animation: 150,
        handle: ".drag-handle",
      });
    }
  }

  return Cart;
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $("#AddressNewForm");

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector(
      "AddressCountryNew",
      "AddressProvinceNew",
      {
        hideElement: "AddressProvinceContainerNew",
      }
    );
  }

  // Initialize each edit form's country/province selector
  $(".address-country-option").each(function () {
    var formId = $(this).data("form-id");
    var countrySelector = "AddressCountry_" + formId;
    var provinceSelector = "AddressProvince_" + formId;
    var containerSelector = "AddressProvinceContainer_" + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector,
    });
  });

  // Toggle new/edit address forms
  $(".address-new-toggle").on("click", function () {
    $newAddressForm.toggleClass("hide");
  });

  $(".address-edit-toggle").on("click", function () {
    var formId = $(this).data("form-id");
    $("#EditAddress_" + formId).toggleClass("hide");
  });

  $(".address-delete").on("click", function () {
    var $el = $(this);
    var formId = $el.data("form-id");
    var confirmMessage = $el.data("confirm-message");
    if (
      confirm(confirmMessage || "Are you sure you wish to delete this address?")
    ) {
      Shopify.postLink("/account/addresses/" + formId, {
        parameters: { _method: "delete" },
      });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: "#RecoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register("product", theme.Product);
  sections.register("cart", theme.Cart);

  // Center mobile horizontal menu on active link
  var mobileMenu = $(".site-nav .mobile-nav ul");
  var activeLinkPosition = $("li.active", mobileMenu).position();
  if (activeLinkPosition && activeLinkPosition.left) {
    mobileMenu.scrollLeft(activeLinkPosition.left - 50);
  }

  var supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;
  if (supportsTouch) {
    var HoverOnTouch = new window.HoverOnTouch();
  } else {
    function toggleAktiv() {
      $(this).toggleClass("hoverontouch--aktiv");
    }
    $(".maximum-grid.with-image a").hover(toggleAktiv, toggleAktiv);
  }

  // Text block buttons hover
  // function togglePlain() { $(this).toggleClass('plain'); }
  // $('a.text-block, button.text-block, input[type="submit"].text-block').hover(togglePlain, togglePlain);

  // Menu headroom
  $("body").headroom({
    offset: 30,
    tolerance: 10,
  });

  // Product nav
  $(".accordion-section-link").click(function () {
    $("html, body").animate(
      { scrollTop: $(".accordion-section").offset().top - 150 },
      250
    );
  });

  $(".slider").slick({
    dots: true,
    infinite: true,
    speed: 300,
    centerMode: true,
    centerPadding: "20px",
    variableWidth: true,
    autoplay: true,
  });

  // Accordion
  var allPanels = $(".accordion > .content").hide();
  $(".accordion > .header > .minus").hide();
  // $(".accordion > .header:first-child").next().addClass("active").slideDown(0);
  // $(".accordion > .header:first-child > .plus").hide();
  // $(".accordion > .header:first-child > .minus").show();
  $(".accordion > .header").click(function () {
    $this = $(this);
    $target = $this.next();
    if ($target.hasClass("active")) {
      $this.find(".plus").show();
      $this.find(".minus").hide();
      $target.removeClass("active").slideUp(20);
    } else {
      $(".accordion > .header > .plus").show();
      $(".accordion > .header > .minus").hide();
      allPanels.removeClass("active").slideUp(20);
      $this.find(".plus").hide();
      $this.find(".minus").show();
      $target.addClass("active").slideDown(20);
    }
    return false;
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = ".rte table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "rte__table-wrapper",
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: "rte__video-wrapper",
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className =
      document.documentElement.className.replace(
        "supports-no-cookies",
        "supports-cookies"
      );
  }
});

// Add click handler for the request quote button
$("#request-quote").on("click", () => {
  // Get selected options and quantity
  const form = $('form[action="/cart/add"]');
  const quantity = form.find('input[name="quantity"]').val();
  const variant = form.find('select[name="id"] option:selected').text().trim();
  const productName = $('[itemprop="name"]').text().trim();

  // Build message with product details
  const message =
    `Demande de devis pour ${productName}\n\n` +
    `Variante: ${variant}\n` +
    `Quantité: ${quantity}\n\n` +
    `Merci de me contacter pour un devis personnalisé.`;

  // Save to localStorage with form-specific key
  const prefillData = {
    "custom#message": message,
  };

  localStorage.setItem("prefill-form-338221", JSON.stringify(prefillData));
});

// Modified form prefill logic
const observer = new MutationObserver((mutationsList, observer) => {
  const $formEmbed = $("form-embed");
  if ($formEmbed.length) {
    // Get the form ID from the parent element's data attribute
    const formId = $formEmbed
      .closest("[data-forms-id]")
      .attr("data-forms-id")
      ?.split("-")
      .pop();

    if (!formId) {
      return;
    }

    // Check if we have stored prefill data for this form
    const storageKey = `prefill-form-${formId}`;
    const prefillData = localStorage.getItem(storageKey);
    if (!prefillData) {
      return;
    }

    observer.disconnect();

    try {
      const shadow = $formEmbed[0].shadowRoot;
      const parsedData = JSON.parse(prefillData);
      // Find and fill all matching inputs
      $(shadow)
        .find("input, textarea")
        .each(function () {
          const $input = $(this);
          const nameMatch = parsedData[$input.attr("name")];
          const idMatch = parsedData[$input.attr("id")];
          if (nameMatch) {
            $input.val(nameMatch);
          } else if (idMatch) {
            $input.val(idMatch);
          }
        });

      // Add form submission handler
      $(shadow)
        .find("form")
        .on("submit", function () {
          console.log("Form submitted");
          localStorage.removeItem(storageKey);
        });
    } catch (error) {
      console.error("Error prefilling form:", error);
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
